import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintManageEntityList } from './';

/**
 * @component {kat-blueprint-manage-entity-list-action} KatBlueprintManageEntityListAction Component used to place and filter components within the action section.
 * @slot default Blueprint content for action section.
 */
@register(KatBlueprintManageEntityList.slotMapping.action.name)
export class KatBlueprintManageEntityListAction extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintManageEntityList.slotMapping.action.name,
      KatBlueprintManageEntityList.slotMapping.action.allowed
    );
  }
}
